import { createIcon } from '@chakra-ui/react';

export const RotateLeft = createIcon({
  displayName: 'RotateLeft',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
          d="M6.07306 3.38676C6.65306 3.21343 7.29306 3.1001 7.99973 3.1001C11.1931 3.1001 13.7797 5.68676 13.7797 8.8801C13.7797 12.0734 11.1931 14.6601 7.99973 14.6601C4.80639 14.6601 2.21973 12.0734 2.21973 8.8801C2.21973 7.69343 2.57973 6.58676 3.19306 5.66676"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.24707 3.54659L7.17374 1.33325"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.24707 3.54663L7.49374 5.18663"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
